import React from 'react';
import FormsRow, { FormsRowModifier } from '../../../../components/molecules/Form/components/FormsRow/FormsRow';
import { FormSubmitButton } from '../../../../components/molecules/Form/components/FormSubmitButton/FormSubmitButton';
import LiveRegion from '../../../../components/atoms/LiveRegion/LiveRegion';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Assignment, PageToPageAssignmentCard } from '../PageToPageAssignmentCard';
import { Hint } from '../../../../_lib/components/Hint';

type PageToPageCreateEditCommonTemplate = {
  getStatus: (messages: any) => any;
  statusMessages: any;
  submitActionEnabled: () => boolean;
  assignmentPreview?: Assignment;
};

/**
 * Common Form Inputs in the Create and Edit Form of PageToPage.
 */
export function PageToPageCreateEditCommonTemplate({
  getStatus,
  statusMessages,
  submitActionEnabled,
  assignmentPreview,
}: PageToPageCreateEditCommonTemplate) {
  const { t } = useSonTranslation('PageToPage');

  return (
    <>
      {assignmentPreview && (
        <FormsRow>
          <div className="page-to-page-block__form-preview-container">
            <h3 className="page-to-page-block__headline">{t('preview')}</h3>
            <PageToPageAssignmentCard {...assignmentPreview} />
          </div>
        </FormsRow>
      )}
      <FormsRow>
        <Hint message={t('hint')} />
      </FormsRow>
      <FormsRow modifier={FormsRowModifier.NO_MARGIN}>
        <FormSubmitButton buttonLabel={t('submitButtonLabel')} enabled={submitActionEnabled()} />
      </FormsRow>
      <LiveRegion invisible={false}>{getStatus(statusMessages)}</LiveRegion>
    </>
  );
}
